import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcReportData, RpcReportKey } from './rpc-report-model';

export class RpcReportClient {
    /**
     * The report data command.
     *
     * @param data the report data object.
     * @return Promise<void> the promise object.
     */
    public static report(rpc: Rpc, data: RpcReportData): Promise<void> {
        return RpcInboundClient.call(rpc, RpcReportKey.command, RpcReportKey.version, data);
    }
}
